/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AboutQuery = {
    readonly _children: {
        readonly items: ReadonlyArray<{
            readonly brandPacks?: ReadonlyArray<{
                readonly brandTitle?: string;
                readonly darkMode?: boolean;
                readonly logoPreview?: {
                    readonly _url: string | null;
                    readonly _name: string | null;
                };
                readonly sVGResource?: {
                    readonly _name: string | null;
                    readonly _url: string | null;
                } | null;
                readonly pNGResource?: {
                    readonly _name: string | null;
                    readonly _url: string | null;
                } | null;
                readonly ePSResource?: {
                    readonly _name: string | null;
                    readonly _url: string | null;
                } | null;
            } | null> | null;
            readonly metaTitle?: string | null;
            readonly headerTilte?: string;
            readonly headerText?: string | null;
            readonly photoCarousel?: ReadonlyArray<{
                readonly picture?: string;
                readonly fullImage?: string | null;
            } | null> | null;
            readonly infoItems?: ReadonlyArray<{
                readonly text?: string;
                readonly value?: number;
            } | null>;
            readonly contentText?: string | null;
            readonly contentTitle?: string;
            readonly conferenceFiles?: ReadonlyArray<{
                readonly _id: string;
                readonly _name: string | null;
                readonly _url: string | null;
                readonly umbracoBytes?: number;
                readonly _updateDate?: unknown | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly " $refType": "AboutQuery";
};
export type AboutQuery$data = AboutQuery;
export type AboutQuery$key = {
    readonly " $data"?: AboutQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"AboutQuery">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboutQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishedContentConnection",
      "kind": "LinkedField",
      "name": "_children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "brandPacks",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "brandTitle",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "darkMode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "logoPreview",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "sVGResource",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "pNGResource",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "ePSResource",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "type": "BrandPackPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "metaTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "headerTilte",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "headerText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "photoCarousel",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "picture",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "fullImage",
                          "storageKey": null
                        }
                      ],
                      "type": "CarouselItemPicturePublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "infoItems",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "text",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "value",
                          "storageKey": null
                        }
                      ],
                      "type": "InfoItemPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "conferenceFiles",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "_id",
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "umbracoBytes",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "_updateDate",
                          "storageKey": null
                        }
                      ],
                      "type": "FilePublishedMedia",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "AboutPublishedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
})();
(node as any).hash = 'e550fadce48917734e85fdf4d0a224ab';
export default node;
